import router from '@/router';
import {
  clearAuthTokens
} from "axios-jwt";

export default function() {
  clearAuthTokens();
  router.push({name: 'login'});
}